/**
 * Patient consent service — calls the backend consent API.
 *
 * Used by AudioRecorder to grant all required consents before
 * opening the WebSocket for STT streaming.
 */
import apiClient from './apiClient';
import { API_URL } from '../config';

export interface ConsentRecord {
  id: number;
  patient_id: string;
  consent_type: string;
  granted: boolean;
  granted_at: string | null;
  revoked_at: string | null;
  session_id: string | null;
  notes: string | null;
}

export interface ConsentValidation {
  valid: boolean;
  reason: string;
}

/**
 * Grant all standard consent types (transcription, storage, ai_processing)
 * for a patient + session pair. Must be called BEFORE opening the WS.
 */
export async function grantAllConsent(
  patientId: string,
  sessionId: string,
): Promise<ConsentRecord[]> {
  const { data } = await apiClient.post<ConsentRecord[]>(
    `${API_URL}/consent/grant-all`,
    { patient_id: patientId, session_id: sessionId },
  );
  return data;
}

/**
 * Validate that all required consents exist for a patient.
 */
export async function validateConsent(
  patientId: string,
): Promise<ConsentValidation> {
  const { data } = await apiClient.get<ConsentValidation>(
    `${API_URL}/consent/validate/${encodeURIComponent(patientId)}`,
  );
  return data;
}
